import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./RegJourney.css";

const RegJourney = () => {
  const personalHubData = [
    {
      title: "Expert Guidance",
      description:
        "Our team guides you through every step of registration, ensuring a smooth and hassle-free experience.",
      icon: "bi-people-fill", // filled team guidance icon
    },
    {
      title: "Quick Verification",
      description:
        "We verify your documents and information promptly so you can start using our services without delays.",
      icon: "bi-patch-check-fill", // filled verification icon
    },
    {
      title: "Real-Time Updates",
      description:
        "Stay informed with instant notifications on the status of your registration and submissions.",
      icon: "bi-bell-fill", // filled alert/notification icon
    },
    {
      title: "Dedicated Support",
      description:
        "Our friendly support team is always available to answer your questions and resolve any issues.",
      icon: "bi-headset", // filled headset support icon
    },
  ];

  return (
    <>
      <div className="container-fluid regMainJourney py-5">
        <div className="container">
          {/* -------- Section 1: Slider -------- */}
          <div className=" mb-5">
            <div
              className="font-12 ff-semibold text-center glair-wrap bg-3 d-flex align-items-center gap-1 px-3 my-3 rounded-pill"
              style={{ width: "fit-content" }}
            >
              <span className="ms-1 glair">Track, Manage, and Relax</span>
            </div>

            <h2 className="text-left font-25 font-sm-14 text-black ff-bold mb-3">
              Personal Hub at Goodhand
            </h2>
          </div>

          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            loop={true}
            spaceBetween={15}
            breakpoints={{
              320: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="regMainSwiper pb-5"
          >
            {personalHubData.map((card, index) => (
              <SwiperSlide key={index} className="py-3 bg-transparent">
                <div className="regMainCard text-center p-4 bg-white shadow-sm rounded-4 h-100 d-flex align-items-center justify-content-between flex-column">
                  <div className="mb-3 text-main-grad d-flex align-items-center justify-content-center">
                    <i className={`bi ${card.icon} font-30 icon-gradient`}></i>
                  </div>

                  <h5 className="font-16 ff-bold text-black mb-2">
                    {card.title}
                  </h5>
                  <p className="font-12 text-muted reg-desc">
                    {card.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="row align-items-start ">
            <div className="col-md-12 text-center mt-4 mt-md-0">
              <img
                src="https://goodhand.b-cdn.net/Assets/Registration/app-view.png"
                alt="Laptop"
                className="img-fluid regMainImage"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegJourney;
